module.exports = __webpack_public_path__ + "img/subject_banner8.9110fb4c.png";